module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/theme/packages/core-app/src/templates/appProgressView.html -->\n<article class="content content--modal">\n	<p class="mdc-typography--body1">'+
((__t=( message ))==null?'':_.escape(__t))+
'</p>\n	<div role="progressbar" class="progress mdc-linear-progress '+
((__t=( indeterminate ? 'mdc-linear-progress--indeterminate' : '' ))==null?'':_.escape(__t))+
'">\n		<div class="mdc-linear-progress__buffering-dots"></div>\n		<div class="mdc-linear-progress__buffer"></div>\n		<div class="mdc-linear-progress__bar mdc-linear-progress__primary-bar">\n			<span class="mdc-linear-progress__bar-inner"></span>\n		</div>\n		<div class="mdc-linear-progress__bar mdc-linear-progress__secondary-bar">\n			<span class="mdc-linear-progress__bar-inner"></span>\n		</div>\n	</div>\n</article>\n';
}
return __p;
};
